import { AttachmentUploadModel } from './../models/Attachment/AttachmentUploadModel';
import { AttachmentModel, AttachmentModelResult } from 'src/app/models/Attachment/AttachmnetModel';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiControllerActionEnum } from '../models/enums/ApiControllerActionEnum';
import { ImageHandlerResponseModel } from 'src/app/models/Attachment/ImageHandlerResponseModel'
import { map } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import { env } from 'process';
import { environment } from 'src/environments/environment';
import  * as uuid from 'uuid';
@Injectable({
  providedIn: 'root'
})
export class AttachmentService {

  constructor(private http: HttpClient, private domSanitizer: DomSanitizer) { }

  imageHandler(referenceId, scopeId, typeId) {
    return this.http.get(ApiControllerActionEnum.ImageHandler + `?referenceId=${referenceId}&scopeId=${scopeId}&typeId=${typeId}`,{ responseType: 'text' });
    // return this.http.get<ImageHandlerResponseModel>(ApiControllerActionEnum.ImageHandler + `?referenceId=${referenceId}&scopeId=${scopeId}&typeId=${typeId}`)
    //   .pipe(map((receivedData) => {
    //     if (receivedData.fileStream != null) {
    //
    //       var file = new Blob([receivedData.fileStream]);
    //       let objectURL = URL.createObjectURL(file);
    //       //let sanitizedUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(objectURL)
    //       return objectURL;
    //     }
    //     return receivedData.attachmentUrl;
    //   }));
  }

  getIdentityAttachemnt(referenceId, scopeId) {
    return this.http.get<AttachmentModelResult>(ApiControllerActionEnum.GetIdentityAttachemnt + `?referenceId=${referenceId}&scopeId=${scopeId}`);
  }

  uploadAttachmnet(formdata: FormData) {


    const headers = new HttpHeaders({
      'Content-Type': 'multipart/form-data',
      'Accept': 'application/json'
    });


    let options = { headers: headers };
    return this.http.post(ApiControllerActionEnum.UploadFile, formdata);
  }
  modelToFormData(model) {
    var formData: FormData = new FormData();
    for (let key of Object.keys(model)) {
      let val = model[key];
      if (key == 'formFile') {
        formData.append(key, val, val.name);
        continue
      }


      formData.append(key, val);
    }


    return formData;
  }
  capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }
  getImageLink(referenceId, scopeId, typeId,imageGallery?) {

    let param = '?';
    if (referenceId != null) {
      param=this.isFirstQyeryParam(param)?param:(param+='&');
      param += 'referenceId=' + referenceId
    }
    if (scopeId != null) {
      param=this.isFirstQyeryParam(param)?param:(param+='&');
      param += 'scopeId=' + scopeId
    }
    if (typeId != null) {
      param=this.isFirstQyeryParam(param)?param:(param+='&');
      param += 'typeId=' + typeId
    }
    if (imageGallery != null) {
      param=this.isFirstQyeryParam(param)?param:(param+='&');
      param += 'imageGallery=' + imageGallery
    }
    let url=environment.apiUrl +ApiControllerActionEnum.Handler_ImageHandler+param;
    return url;
  }
  getImageLinkUnique(referenceId, scopeId, typeId,imageGallery?) {

    let param = '?';
    //param+='&random='+uuid.v4();
    if (referenceId != null) {
      param=this.isFirstQyeryParam(param)?param:(param+='&');
      param += 'referenceId=' + referenceId
    }
    if (scopeId != null) {
      param=this.isFirstQyeryParam(param)?param:(param+='&');
      param += 'scopeId=' + scopeId
    }
    if (typeId != null) {
      param=this.isFirstQyeryParam(param)?param:(param+='&');
      param += 'typeId=' + typeId
    }
    if (imageGallery != null) {
      param=this.isFirstQyeryParam(param)?param:(param+='&');
      param += 'imageGallery=' + imageGallery
    }

    let url=environment.apiUrl +ApiControllerActionEnum.Handler_ImageHandler+param;
    return url;
  }
  getMMYCarImageLink(referenceId, scopeId, typeId,makeID,modelID,year){

    let param=`?scopeId=${scopeId}&typeId=${typeId}&makeID=${makeID}&modelID=${modelID}&year=${year}`;
    let url=environment.apiUrl +ApiControllerActionEnum.Handler_ImageHandler+param;
    return url;
  }
  isFirstQyeryParam(param) {
    if (param == '' || param == '?')
      return true;
    return false;
  }

}
